module.exports = __webpack_public_path__ + "static/media/erge.9f15c27b.webp";